import { IInterventionTimeline } from 'models/InterventionDetails';

import { ReduxStore } from 'store/types';

function getDetailsTimeline(state: ReduxStore): IInterventionTimeline[] {
  return state.intervention.getDetails.timeline;
}

export default getDetailsTimeline;
